import './NOSCards.css';
import React from 'react';
import { get } from '../../../utils';
import { useSitecoreContext } from '../../../utils/SitecoreContextReactContext';
import { Link, Text } from '@sitecore-jss/sitecore-jss-react';
import RouterLink from '../../atoms/RouterLink';
import ScrollAnimation from 'react-animate-on-scroll';
import { ReactComponent as IconChevronRightLight } from '../../../resources/icons/IconChevronRightLight.svg';
import { ReactComponent as IconChevronLeftLight } from '../../../resources/icons/IconChevronLeftLight.svg';
import LazyPicture from '../../atoms/LazyPicture';
import CarouselProvider from '../../atoms/CarouselProvider/CarouselProvider';
import { convertToAnalyticObject } from '../../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickNewData } from '../../../utils/tealium';
var Cards = function Cards(_ref) {
  var item = _ref.item,
    itemsLength = _ref.itemsLength,
    eventsAnalytics = _ref.eventsAnalytics,
    params = _ref.params;
  var sitecoreContext = useSitecoreContext();
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var cardImageSrc = get(item, 'image.jss.value.src');
  var cardImageAlt = get(item, 'image.jss.value.alt');
  var hasTitle = get(item, 'title.jss.value');
  var hasDescription = Boolean(get(item, 'description.jss.value'));
  var ctaLabel = get(item, 'ctaLabel.jss.value');
  var ctaLinkHref = get(item, 'ctaLink.jss.value.href');
  var cardTitle = get(item, 'title.jss.value');
  var renderContentInLink = function renderContentInLink(children) {
    if (!ctaLinkHref && !pageEditing) return /*#__PURE__*/React.createElement("div", {
      className: "withoutLink"
    }, children);
    var linkTitle = '';
    if (hasTitle && hasTitle) {
      linkTitle = hasTitle;
    } else {
      linkTitle = cardImageAlt ? cardImageAlt : '';
    }
    if (ctaLabel) {
      linkTitle = "".concat(ctaLabel, " | ").concat(linkTitle);
    }
    if (item.ctaLink.jss && item.ctaLink.jss.value && item.ctaLink.jss.value.target === "_blank") {
      linkTitle = linkTitle ? "".concat(linkTitle) : "";
    }
    return /*#__PURE__*/React.createElement(Link, {
      "aria-label": linkTitle,
      field: item.ctaLink.jss
    }, children);
  };
  var renderLink = function renderLink() {
    if (!ctaLabel || !ctaLinkHref) return null;
    if (pageEditing && ctaLinkHref) {
      return /*#__PURE__*/React.createElement(Link, {
        field: item.ctaLink.jss
      });
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "c--link-more"
    }, /*#__PURE__*/React.createElement(RouterLink, {
      className: "general-card-button",
      href: item.ctaLink.jss.value.href,
      linktype: "external",
      openInSameTab: true,
      onClick: function onClick() {
        return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['linkClickAnalytics'], params), [cardTitle, ctaLabel]);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "btn-tertiary__text"
    }, ctaLabel && ctaLinkHref ? ctaLabel : null), ctaLabel && ctaLinkHref ? rtl ? /*#__PURE__*/React.createElement(IconChevronLeftLight, null) : /*#__PURE__*/React.createElement(IconChevronRightLight, null) : null));
  };
  var renderCardsViewTwo = function renderCardsViewTwo() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, (hasTitle || hasDescription || renderLink()) && /*#__PURE__*/React.createElement("div", {
      className: "card-box theme-contrast nos-cards-image-wrapper-for-two ".concat(itemsLength === 1 ? "nos-cards-image-one" : "")
    }, cardImageSrc ? renderContentInLink(/*#__PURE__*/React.createElement(LazyPicture, {
      onClick: function onClick() {
        tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['bannerClickAnalytics'], params), cardTitle);
      },
      useEmptyPlaceholder: true,
      hover: true,
      className: "NOSCardsImageForTwoItems"
    }, /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 768px)",
      srcSet: "".concat(cardImageSrc, "&cw=500&ch=375")
    }), /*#__PURE__*/React.createElement("img", {
      src: "".concat(cardImageSrc, "&cw=500&ch=375"),
      alt: cardImageAlt
    }))) : null, /*#__PURE__*/React.createElement("div", {
      className: "textContainerForTwo"
    }, hasTitle ? /*#__PURE__*/React.createElement(Text, {
      tag: "p",
      className: "h__title body-large cardTitleForTwoItems",
      field: item.title && item.title.jss,
      onClick: function onClick() {
        tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['titleClickAnalytics'], params), cardTitle);
      }
    }) : null, hasDescription ? /*#__PURE__*/React.createElement(Text, {
      tag: "p",
      className: "h__title body-large cardDescription",
      field: item.description && item.description.jss
    }) : null, renderLink())));
  };
  var renderCardsViewThree = function renderCardsViewThree() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, (hasTitle || hasDescription || renderLink()) && /*#__PURE__*/React.createElement("div", {
      className: "card-box theme-contrast nos-cards-image-wrapper-for-three"
    }, cardImageSrc ? renderContentInLink(/*#__PURE__*/React.createElement(LazyPicture, {
      onClick: function onClick() {
        tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['bannerClickAnalytics'], params), cardTitle);
      },
      useEmptyPlaceholder: true,
      hover: true,
      className: "NOSCardsImageForThreeAndFourItems"
    }, /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 768px)",
      srcSet: "".concat(cardImageSrc, "&cw=500&ch=375")
    }), /*#__PURE__*/React.createElement("img", {
      src: "".concat(cardImageSrc, "&cw=500&ch=375"),
      alt: cardImageAlt
    }))) : null, /*#__PURE__*/React.createElement("div", {
      className: "textContainer"
    }, hasTitle ? /*#__PURE__*/React.createElement(Text, {
      tag: "p",
      className: "h__title body-large cardTitle",
      field: item.title && item.title.jss,
      onClick: function onClick() {
        tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['titleClickAnalytics'], params), cardTitle);
      }
    }) : null, hasDescription ? /*#__PURE__*/React.createElement(Text, {
      tag: "p",
      className: "h__title body-large cardDescription",
      field: item.description && item.description.jss
    }) : null, renderLink())));
  };
  var renderCardsViewFour = function renderCardsViewFour() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, (hasTitle || hasDescription || renderLink()) && /*#__PURE__*/React.createElement("div", {
      className: "card-box-without-alignment theme-contrast"
    }, cardImageSrc ? renderContentInLink(/*#__PURE__*/React.createElement(LazyPicture, {
      onClick: function onClick() {
        tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['bannerClickAnalytics'], params), cardTitle);
      },
      useEmptyPlaceholder: true,
      hover: true,
      className: "NOSCardsImageForThreeAndFourItems"
    }, /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 768px)",
      srcSet: "".concat(cardImageSrc, "&cw=500&ch=375")
    }), /*#__PURE__*/React.createElement("img", {
      src: "".concat(cardImageSrc, "&cw=500&ch=375"),
      alt: cardImageAlt
    }))) : null, /*#__PURE__*/React.createElement("div", {
      className: "textContainer"
    }, hasTitle ? /*#__PURE__*/React.createElement(Text, {
      onClick: function onClick() {
        tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['titleClickAnalytics'], params), cardTitle);
      },
      tag: "p",
      className: "h__title body-large cardTitle",
      field: item.title && item.title.jss
    }) : null, hasDescription ? /*#__PURE__*/React.createElement(Text, {
      tag: "p",
      className: "h__title body-large cardDescription",
      field: item.description && item.description.jss
    }) : null, renderLink())));
  };
  var generalCardsImageMap = {
    '1': renderCardsViewTwo,
    '2': renderCardsViewTwo,
    '3': renderCardsViewThree,
    '4': renderCardsViewFour
  };
  if (itemsLength <= 4) {
    return generalCardsImageMap[itemsLength]();
  }

  // for Carousel only
  return renderCardsViewFour();
};
var NOSCards = function NOSCards(_ref2) {
  var fields = _ref2.fields,
    params = _ref2.params;
  var sitecoreContext = useSitecoreContext();
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var hasTitle = Boolean(get(fields, 'data.item.title.jss.value'));
  var title = get(fields, 'data.item.title.jss.value');
  var hasDescription = Boolean(get(fields, 'data.item.description.jss.value'));
  var childrenItems = get(fields, 'data.item.children', []);
  var ctaLabel = get(fields, 'data.item.ctaLabel.jss.value');
  var ctaLink = get(fields, 'data.item.ctaLink.jss.value.href');
  var items = childrenItems.length ? childrenItems.filter(function (item) {
    return item.title && item.description;
  }) : [];
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var renderButtonLink = function renderButtonLink() {
    return /*#__PURE__*/React.createElement("div", {
      className: "btnLink"
    }, /*#__PURE__*/React.createElement(RouterLink, {
      className: "btn",
      href: ctaLink,
      title: ctaLabel,
      openInSameTab: true,
      linktype: "external",
      onClick: function onClick() {
        return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['seeMoreAnalytics'], params), [title, ctaLabel]);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "btnText"
    }, ctaLabel)));
  };
  var renderItems = function renderItems() {
    return items.map(function (item, index) {
      return /*#__PURE__*/React.createElement(ScrollAnimation, {
        style: {
          flex: 1
        },
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1 + index / 3,
        key: index
      }, /*#__PURE__*/React.createElement(Cards, {
        item: item,
        itemsLength: items.length,
        eventsAnalytics: eventsAnalytics,
        params: params
      }));
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, items.length < 5 && (hasTitle || hasDescription) ? /*#__PURE__*/React.createElement("div", {
    className: "h__txt"
  }, hasTitle ? /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: "h3 h__title componentTitle",
    field: fields.data.item.title.jss
  }) : null, hasDescription ? /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "p componentDescription",
    field: fields.data.item.description.jss
  }) : null) : null, items.length < 5 ? /*#__PURE__*/React.createElement("div", {
    className: "itemsContainer"
  }, renderItems()) : null, items.length >= 5 ? /*#__PURE__*/React.createElement(CarouselProvider, null, function (_ref3) {
    var renderCarousel = _ref3.renderCarousel,
      renderPreviousButton = _ref3.renderPreviousButton,
      renderNextButton = _ref3.renderNextButton,
      renderDots = _ref3.renderDots;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "".concat(hasTitle || hasDescription ? 'card__head' : 'cardHeadOnlyWithPagination')
    }, hasTitle || hasDescription ? /*#__PURE__*/React.createElement("div", {
      className: "h__txt"
    }, hasTitle ? /*#__PURE__*/React.createElement(Text, {
      tag: "h3",
      className: "h3 h__title componentTitle",
      field: fields.data.item.title.jss
    }) : null, hasDescription ? /*#__PURE__*/React.createElement(Text, {
      tag: "p",
      className: "p componentDescription",
      field: fields.data.item.description.jss
    }) : null) : null, /*#__PURE__*/React.createElement("div", {
      className: "pagination__btn"
    }, /*#__PURE__*/React.createElement("div", {
      className: "btn-group--right ".concat(rtl ? 'btn-group-rtl' : '')
    }, renderPreviousButton(function () {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['prevNavAnalytics'], params));
    }), renderNextButton(function () {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['nextNavAnalytics'], params));
    })))), /*#__PURE__*/React.createElement("div", {
      className: "card-container__inner"
    }, renderCarousel(renderItems(), {
      responsive: {
        extra: {
          breakpoint: {
            max: 10000,
            min: 1101
          },
          items: 4
        },
        desktop: {
          breakpoint: {
            max: 1100,
            min: 901
          },
          items: 3
        },
        tablet: {
          breakpoint: {
            max: 900,
            min: 480
          },
          items: 2
        },
        mobile: {
          breakpoint: {
            max: 479,
            min: 0
          },
          items: 1
        }
      },
      containerClass: 'carouselContainer'
    })), ctaLink && ctaLabel ? /*#__PURE__*/React.createElement("div", {
      className: "paginationAndLinkContainer"
    }, renderButtonLink(), /*#__PURE__*/React.createElement("div", {
      className: "pagination-dot"
    }, renderDots(function () {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['navBubblesAnalytics'], params));
    }))) : /*#__PURE__*/React.createElement("div", {
      className: "paginationWithoutLinkContainer"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pagination-dot"
    }, renderDots(function () {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['navBubblesAnalytics'], params));
    }))));
  }) : null);
};
var StyledWrapper = function StyledWrapper(_ref4) {
  var children = _ref4.children,
    rtl = _ref4.rtl,
    className = _ref4.className,
    style = _ref4.style;
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(className)
  }, children);
};
var generalCardTitle = "\n  font-weight: 500;\n  color: #000;\n\n  @media (max-width: 992px) {\n    font-size: 22px;\n    margin-bottom: 18px;\n  }\n\n  .contrast & {\n    color: #000;\n  }\n";
var generalPaginationLinkContainer = "\n  display: flex;\n  align-items: center;\n\n  padding-top: 20px;\n\n  @media (max-width: 992px) {\n    padding-top: 0;\n    flex-direction: column-reverse;\n  }\n";
export var commonStyles = "c1116aqt";
export var ltrStyles = "l14w22le";
export var rtlStyles = "rng2ai6";
export { NOSCards };